import { composeIO } from 'react-compose-io'
import { modalTipoStatusIO } from './ModalTipoStatus.IO'
import ModalTipoStatusView from './ModalTipoStatus.View'

export const ModalTipoStatus = composeIO(ModalTipoStatusView, modalTipoStatusIO)
